import React, {Component} from 'react'
import popup from '../../popup'
import { cancelSubscription } from '../../../../redux/user/helpers'

import './style.css'

class View extends Component {
  constructor(props) {
    super(props)
    this.state = {
      fields: props.args.fields
    }
    this.cancelMySubscription = this.cancelMySubscription.bind(this)
  }

  cancelMySubscription() {
    cancelSubscription().then( popup.hide )
  }

  render() {
    return (
      <div className="cancel-subscription centered">
        <div className="header">
          <h1>{this.state.fields.cancelPlanHeaderLabel}</h1>
          <p>{this.state.fields.cancelPlanConfirmationMessage}</p>
        </div>
        <div className="buttons">
          <div className="button outlined" onClick={ _ => { popup.hide() } }>{this.state.fields.cancelNoLabel}</div>
          <div className="button site-background-color" onClick={this.cancelMySubscription}>{this.state.fields.cancelYesLabel}</div>
        </div>
      </div>
    )
  }
}

export default View;